angular.module('admin')

.controller('AgentNewClientCtrl', ['$scope', '$state', 'HomeService', 'UtilService', 'ScrollService', 'HelperService', 'AgentService', 'FEATURES',
function($scope, $state, HomeService, utils, ScrollService, helpers, AgentService, FEATURES){
    $scope.agentId =  $state.params.id;

    $scope.savedHome = {};

    $scope.reset = function(){
      $scope.newUser1 = { borrowerType: 'borrower' };
      $scope.newUser2 = { borrowerType: 'coborrower' };
      $scope.newHome = {};
    };

    $scope.addHomeAndUsers = function(){
      $scope.loading = true;
      $scope.newHomeAndUserError = '';
      $scope.addingHomeAndUserSuccess = false;

      var error = function(err){
        $scope.newHomeAndUserError = Array.isArray(err)?err[0]:err;
        utils.trackException('Add Home and User', err);
        $scope.loading = false;
      };

      if($scope.newUser1.mobile)
        $scope.newUser1.mobile = helpers.formatPhone($scope.newUser1.mobile);

      if($scope.newUser2.mobile)
        $scope.newUser2.mobile = helpers.formatPhone($scope.newUser2.mobile);

      var client = {
        home: $scope.newHome,
        users: [$scope.newUser1]
      };

      if($scope.newUser2.email)
        client.users.push($scope.newUser2);

      HomeService.createHome({client: client, agentId: $scope.agentId})
        .then(function(home){
          $scope.savedHome = home;
          $scope.loading = false;
          $scope.addingHomeAndUserSuccess = true;
          $scope.reset();
          ScrollService.scroll({target:'addClientTop'});
        }).catch(error);

    };

    $scope.setShowV2Digest = function(){
      return AgentService.getOne($scope.agentId)
        .then(function(agent){
          $scope.showV2Digest = _.contains(agent.features, FEATURES.DIGEST_V2)
        })
        .catch(function(e){
          $scope.showV2Digest = false;
        });
    };

    $scope.reset();
    $scope.setShowV2Digest();

  }]);
